import { convertHexToRGBA } from '@utils/usefulFuncs';
import styled from 'styled-components';

export const InputWrapper = styled.div`
  position: relative;
  min-width: 120px;
  width: 100%;
  flex: 1;
`;
export const InputStyling = styled.div`
  border: 1px solid ${({ theme }) => theme.themeColors.border};
  color: ${({ theme }) => theme.themeColors.text};
  background-color: transparent;
  border-radius: 6px;
  width: 100%;
  padding: 8px;

  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  flex-wrap: wrap;
  gap: 8px;
  min-height: 42px;

  input {
    font-size: 14px;
    border: none !important;
    padding: 0 0 0 1px !important;
    outline: none;
    line-height: 18px;
    width: 100%;
    cursor: text;
  }
`;
export const SelectableTagsWrapper = styled.div`
  position: relative;
  width: 100%;
`;
export const SelectableTagWrapper = styled.div`
  color: ${({ theme, isSelected }) => (isSelected ? theme.themeColors.buttonText : theme.themeColors.text)};
  background: ${({ theme, isSelected }) =>
    isSelected ? theme.themeColors.primaryCtaButton : convertHexToRGBA(theme.themeColors.appBackground, 0.3)};
  border-bottom: 1px solid ${({ theme }) => theme.themeColors.lowContrastBorder};
  cursor: pointer;

  padding: 8px 12px;
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;

  transition: all 150ms;

  * {
    color: ${({ theme, isSelected }) => (isSelected ? theme.themeColors.buttonText : theme.themeColors.text)};
  }

  &:hover {
    // background: ${({ theme }) => convertHexToRGBA(theme.themeColors.primaryCtaButton, 0.75)};
    background: ${({ theme }) => theme.themeColors.primaryCtaButton};
    color: ${({ theme }) => theme.themeColors.buttonText};

    * {
      color: ${({ theme }) => theme.themeColors.buttonText};
    }
  }
`;
export const SelectableTagsPositionWrapper = styled.div`
  position: absolute;
  top: 14px;
  left: -8px;
  right: -8px;
  max-height: 60vh;
  overflow: auto;
  z-index: 5;
  box-shadow: inset 0 -1px 0 rgba(0, 0, 0, 0.25);

  background: ${({ theme }) => theme.themeColors.componentNoOpacity};
  border: 1px solid ${({ theme }) => theme.themeColors.border};
  border-top-left-radius: 1px;
  border-bottom-left-radius: 5px;
  border-bottom-right-radius: 5px;
  border-top-right-radius: 1px;
`;
export const TruncateText = styled.span`
  width: 100%;

  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;
export const CloseIconWrapper = styled.div``;
